import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box, Card, CardContent, Grid, Skeleton, Stack, Button, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import API from 'services/AxiosConfig';
import Analytic from '../../Analytic';
import { Typography } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import ProgressModalContent from './ProgressModalContent';
export const ProgressCards = ({ val, idx, id, fetchData, stageUrl, type }: any) => {
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState<any>({});
  const [initialVals, setInitialVals] = useState({});
  const handleEditOpen = (name: any, item: any, idx: any) => {
    setEditData({ cardName: name, items: item, idx: idx });
    setOpen(true);
  };
  const handleCloseModal = () => {
    setOpen(false);
    fetchData(stageUrl);
  };
  useEffect(() => {
    let obj: any = {};
    for (const key in editData?.items) {
      obj[editData?.items[key]?.label] = editData?.items[key]?.label;
    }
    setInitialVals(obj);
  }, [editData]);
  return (
    <>
      {open ? (
        <ProgressModalContent
          open={open}
          closeMe={handleCloseModal}
          id={id}
          fetchData={fetchData}
          URLPATH={stageUrl}
          currentRow={editData?.items}
          title={editData?.cardName?.stage || ''}
          initialVals={initialVals}
          idx={idx}
          type={type}></ProgressModalContent>
      ) : null}
      <Grid item xs={12} md={3} key={idx} mb={3}>
        <Card>
          <CardContent className="card-content">
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={5}>
              <Typography variant="h6" fontWeight={600}>
                {val?.cardName?.stage}
              </Typography>
              <IconButton
                onClick={() => handleEditOpen(val.cardName, val.cardItems, idx)}
                size="small"
                sx={{ color: 'text.secondary' }}>
                <EditIcon />
              </IconButton>
            </Box>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Grid
                container
                spacing={3}
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: '12px',
                  paddingBottom: '10px!important',
                }}>
                {val?.cardItems?.map((row: any, index: any) => {
                  if (!row || !row.label) return null;
                  return (
                    <Grid item xs={12} key={index} style={{ padding: '10px!important' }}>
                      {row.label}
                    </Grid>
                  );
                })}
                <br/>
              </Grid>
            </LocalizationProvider>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};
